<div class="top-menu">
    <div class="logo-container">
        <a routerLink="/" class="logo-link" aria-label="Home">
            <img src="../../../assets/images/gazooky-timewalks-side.svg" class="logo-svg" alt="Gazooky TimeWalks Logo" />
        </a>
    </div>
    <button pButton pRipple icon="pi pi-user" class="p-button-text no-label account-button" (click)="manageUser($event)" #accountBtn>
    </button>
    <p-menu #accountMenu [model]="accountMenuItems" [popup]="true" appendTo="body"></p-menu>
</div>

<!-- Top Section -->
<div style="background-color: #E0E0E0; margin: 0;">
    <!-- Name -->
    <div class="orient" style="gap: 16px; padding: 16px;">
        <div class="flex-row" style="align-items: center; gap: 16px; margin-bottom: 8px;">
            <button pButton type="button" (click)="goBack($event)" class="p-button-text"
                style="min-width: 36px; width: 36px; padding: 0;">
                <img src="assets/images/Return.svg" />
            </button>
            <label for="name"><b>Experience Name</b></label>
            <input id="name" [(ngModel)]="domeName" pInputText aria-describedby="name-help" autocorrect="off"
                maxlength="60" spellcheck="false" autocomplete="off" placeholder="Experience name">

            <ng-container *ngIf="role === 'admin' || role === 'editor' || role === 'super'">
                <button pButton (click)="isUpdate ? onUpdateClicked() : onCreateClicked()"
                    class="blue-button menu-button" tooltipPosition="bottom"
                    [pTooltip]="(!domeName || domeName.length === 0) ? 'Please fill in all required fields' : ''"
                    [disabled]="saving || !domeName || domeName.length === 0"
                    label="Save"><i *ngIf="saving" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i></button>
                <button pButton (click)="onCancelClicked()" class="blue-button menu-button" tooltipPosition="bottom"
                    [pTooltip]="'Close without saving'" [disabled]="saving" label="Exit"></button>
            </ng-container>
        </div>

        <div class="flex-row" style="gap: 16px; margin-bottom: 8px; align-items: stretch;">
            <ng-container *ngIf="role === 'admin' || role === 'editor' || role === 'super'">
                <button pButton (click)="togglePublish()" class="menu-button no-label"
                    [ngClass]="published ? 'blue-button' : 'grey-button'" style="min-width: 48px;">
                    {{published ? "Experience Active" : "Not Active"}}
                    <img [src]="published ? 'assets/images/TickGreen.svg' : 'assets/images/TickGrey.svg'" />
                </button>

                <button type="button" (click)="openExperience()" class="menu-button green-button no-label" pButton
                    [disabled]="originalDome === undefined"
                    [pTooltip]="(originalDome === undefined) ? 'Save Experience to preview it' : ''"
                    tooltipPosition="bottom">
                    Preview
                    <img src="assets/images/Preview.svg" />
                </button>

                <button type="button" (click)="showExperienceQR()" class="menu-button blue-button no-label" pButton
                    [disabled]="originalDome === undefined"
                    [pTooltip]="(originalDome === undefined) ? 'Save Experience to generate link' : ''"
                    tooltipPosition="bottom">
                    Share Link
                    <img src="assets/images/Link.svg" />
                </button>

                <button type="button" (click)="showDeleteConfirm()" class="menu-button red-button" pButton
                    label="Delete" icon="pi pi-trash" iconPos="right"></button>
            </ng-container>
        </div>
    </div>

    <!-- Main Section -->
    <div class="flex-row" style="background-color: #EEF0EE; padding: 16px;">
        <div class="flex-col" style="width: 30%; padding-right: 16px; padding-top: 16px;">
            <b>Publication Preferences</b>
            <small>Publication design settings</small>
            <b style="margin-top: 8px;">Features</b>
            <small>Building blocks of experience</small>
            <button pButton pRipple class="p-button-raised p-button-text no-label shadow hover-button" style="border: dashed 1px #6f6f6f; border-radius: 8px; padding: 16px; 
                    justify-content: center; background-color: white;"
                (click)="addFeatureShowing = !addFeatureShowing">
                <span style="font-size: 12px; font-weight: bold;">Add a feature to your experience {{addFeatureShowing ?
                    '⌄' : '>'}}</span>
            </button>
            <div class="flex-col shadow" *ngIf="addFeatureShowing"
                style="background-color: #F2F2F2; border: dashed 1px #6f6f6f; border-radius: 8px; margin-top: -12px;
                    justify-content: center; align-items: center; text-align: center; padding-top: 24px; padding-bottom: 12px; gap: 12px;">
                <small>Double click on a component to add it</small>
                <div class="grid-container" style="margin-top: -8px; padding: 8px;">
                    <ng-container *ngFor="let feature of features">
                        <button *ngIf="feature.displayable" pButton
                            class="flex-col p-button-text no-label grid-item hover-button"
                            style="justify-content: center; background-color: #F2F2F2;" (click)="addFeature(feature)">
                            <img src="{{feature.image}}" style="width: 20px; height: 20px;" />
                            <span>{{feature.name}}</span>
                        </button>
                    </ng-container>
                </div>
            </div>

            <!-- Features -->
            <div
                style="padding: 4px; gap: 4px; display: flex; flex-direction: column;" dragula="DRAGULA_FACTS" [(dragulaModel)]="addedFeatures">
                    <div *ngFor="let feature of addedFeatures">
                        <div *ngIf="feature.displayable" class="feature shadow"
                        [ngStyle]="{'margin-bottom': feature.activated ? '4px' : '0px'}">
                            <button
                                [ngStyle]="{'background-color': selectedFeature !== undefined && selectedFeature.id === feature.id ? '#FFFFFF' : '#EEEEEE'}"
                                style="display: flex; flex-direction: row; gap: 8px; align-items: center; width: 100%; border: none; border-radius: 8px;"
                                (click)="selectedFeature = feature" class="no-label">
                                <img src="/assets/images/Drag.svg" class="handle" style="padding: 8px;" />
                                <img src="{{feature.image}}" style="width: 20px; height: 20px;" />
                                {{feature.name}}
                                <button (click)="toggleFeature(feature, $event)"
                                    style="border: none; outline: none; background-color: transparent; right: 0; margin-left: auto;">
                                    <img
                                        [src]="feature.enabled ? 'assets/images/toggle_on.svg' : 'assets/images/toggle_off.svg'" />
                                </button>
                            </button>
                        </div>
                    </div>
            </div>
        </div>

        <div class="flex-col" style="gap: 16px; width: 100%;">
            <ng-container *ngIf="colourFeature !== undefined" [ngTemplateOutlet]="colourTemplate"
                [ngTemplateOutletContext]="{colour: colourFeature, geo: geo, logo: logoFeature}"></ng-container>

            <ng-container *ngIf="selectedFeature !== undefined" [ngTemplateOutlet]="featureHeader"
                [ngTemplateOutletContext]="{feature: selectedFeature}"></ng-container>

            <div *ngIf="selectedFeature !== undefined" class="shadow" style="background-color: white; padding: 16px;">
                <app-interactive-ar
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'InteractiveAR'"
                    [feature]="selectedFeature"
                    [models]="models"
                    [clientId]="clientId"
                    [voices]="voices"
                    [animations]="animations"
                    [config]="_config"
                    (featureChange)="updateFeature($event)">
                </app-interactive-ar>

                <app-gallery
                *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Gallery'"
                    [feature]="selectedFeature"
                    [maxImageSize]="maxImageSize"
                    (featureChange)="updateFeature($event)">
                </app-gallery>
                 
                <app-logo
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Logo'" 
                    [feature]="selectedFeature"
                    (featureChange)="updateFeature($event)">
                </app-logo>

                <app-video-upload
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Video'"
                    [maxVideoSize]="maxVideoSize"
                    [feature]="selectedFeature"
                    (featureChange)="updateFeature($event)">
                </app-video-upload>

                <app-website
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Website'"
                    [feature]="selectedFeature"
                    (featureChange)="updateFeature($event)">
                </app-website>

                <app-phone
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Phone'"
                    [feature]="selectedFeature"
                    (featureChange)="updateFeature($event)">
                </app-phone>

                <app-gps
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'GPS'"
                    [feature]="selectedFeature"
                    (featureChange)="updateFeature($event)">
                </app-gps>

                <app-journey
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Journey'"
                    [feature]="selectedFeature"
                    (featureChange)="updateFeature($event)">
                </app-journey>

                <app-app-store
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'AppStore'"
                    [feature]="selectedFeature"
                    (featureChange)="updateFeature($event)">
                </app-app-store>

                <app-blog
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Blog'"
                    [feature]="selectedFeature"
                    [maxImageSize]="maxImageSize"
                    [maxChars]="10000"
                    (featureChange)="updateFeature($event)">
                </app-blog>

                <app-audio
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Audio'"
                    [feature]="selectedFeature"
                    [maxAudioSize]="maxAudioSize"
                    (featureChange)="updateFeature($event)">
                </app-audio>

                <app-navigation
                    *ngIf="selectedFeature !== undefined && selectedFeature.oid === 'Navigation'"
                    [feature]="selectedFeature"
                    [observableDomes]="observableDomesForNavigation"
                    [currentDomeId]="originalDome?.id"
                    (featureChange)="updateFeature($event)">
                </app-navigation>

            </div>
        </div>
    </div>

    <ng-template #featureHeader let-feature="feature">
        <div class="flex-col shadow" style="padding: 12px; background-color: white; gap: 8px;">
            <div class="flex-row" style="gap: 8px">
                <input pInputText autocorrect="off" maxlength="23" spellcheck="false" autocomplete="off"
                    style="border-radius: 8px; max-width: 50%; min-width: 100px;"
                    placeholder="Enter a friendly name for this section." [(ngModel)]="feature.name"
                    [ngModelOptions]="{standalone: true}" />
                <input pInputText maxlength="32"
                    style="border-radius: 8px; max-width: 50%; width: 300px; margin-top: 0px; padding: 8px;"
                    placeholder="Sub title (optional)" [(ngModel)]="feature.sub"
                    [ngModelOptions]="{standalone: true}" />
                <button pButton (click)="showQR(feature)" [disabled]="originalDome === undefined"
                    class="menu-button blue-button no-label" [ngClass]="{'grey-button' : !feature.enabled}"
                    style="min-width: 48px;" *ngIf="feature.canOpen">
                    <span>QR Code</span>
                    <img src="assets/images/QRIcon.svg">
                </button>
                <button pButton (click)="feature.enabled = !feature.enabled" class="menu-button green-button no-label"
                    [ngClass]="{'grey-button' : !feature.enabled}" style="min-width: 48px;">
                    {{published ? "Component Active" : "Not Active"}}
                    <img [src]="feature.enabled ? 'assets/images/TickGreen.svg' : 'assets/images/TickGrey.svg'" />
                </button>
                <button pButton (click)="deleteFeature(feature)" class="menu-button red-button no-label">
                    <span>Delete Component</span>
                    <i class="pi pi-trash"></i>
                </button>
            </div>
            <span style="margin-left: 4px;">Type: {{feature.oid}}</span>
        </div>
    </ng-template>
    <ng-template #colourTemplate let-colour="colour" let-geo="geo" let-logo="logo" >

        <div class="colour-bar">
            
            <div class="p-d-flex p-flex-column">
                <h5 class="p-mb-2">Default Settings</h5>
                <p-tabView class="p-mb-2">
                    <p-tabPanel header="Logo & Color">
                        <div class="logo-and-color">
                            <div class="orient reverse"
                            style="align-items: center; text-align: center; gap: 16px; padding-top: 4px; padding-bottom: 4px;">
                            <div class="flex-col experience-logo" style="max-height: 100%; max-width: 100px;">
                                <img [src]="url" alt="Logo" *ngIf="logo.value && logo.value.url; let url"
                                    style="flex-shrink: 0; width: 100%; height: 100%; min-width: 100%; min-height: 100%; object-fit: contain;">
                                <span *ngIf="!logo.value || !logo.value.url" style="font-size: 10px;">Upload<br />your logo</span>
                                <input #fileInput type="file" (change)="onChangeLogo(logo, $event)" style="display:none;"
                                    accept="image/*" />
                            </div>
                            <button pButton pRipple type="button" (click)="fileInput.click()" class="p-button-text no-label"
                                style="margin-left: -12px; padding: 0;">
                                <img src="assets/images/Icons/Upload.svg" />
                            </button>
                        </div>
                        <div class="colour-container">
                            <small style="padding-top: 4px;">Header</small>
                            <div class="colour-picker">
                                <p-colorPicker ngDefaultControl [(ngModel)]="colour.value.headerColour"
                                    class="colour-square"></p-colorPicker>
                                <input [(ngModel)]="colour.value.headerColour" type="text" pInputText style="width: 66px;">
                            </div>
                        </div>
                        <div class="colour-container">
                            <small style="padding-top: 4px;">Page</small>
                            <div class="colour-picker">
                                <p-colorPicker ngDefaultControl [(ngModel)]="colour.value.bgColour"
                                    class="colour-square"></p-colorPicker>
                                <input [(ngModel)]="colour.value.bgColour" type="text" pInputText style="width: 66px;">
                            </div>
                        </div>
                        <div class="colour-container">
                            <small style="padding-top: 4px;">Button<br />Background</small>
                            <div class="colour-picker">
                                <p-colorPicker ngDefaultControl [(ngModel)]="colour.value.buttonColour"
                                    class="colour-square"></p-colorPicker>
                                <input [(ngModel)]="colour.value.buttonColour" type="text" pInputText style="width: 66px;">
                            </div>
                        </div>
                        <div class="colour-container">
                            <small style="padding-top: 4px;">Button<br />Text</small>
                            <div class="colour-picker">
                                <p-colorPicker ngDefaultControl [(ngModel)]="colour.value.buttonTextColour"
                                    class="colour-square"></p-colorPicker>
                                <input [(ngModel)]="colour.value.buttonTextColour" type="text" pInputText style="width: 66px;">
                            </div>
                        </div>
                        <button pButton pRipple icon="pi pi-refresh" (click)="resetColours(colour)" class="p-button-text no-label"
                            style="margin: -4px;" [pTooltip]="'Reset to default'" tooltipPosition="left"></button>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="GPS Location">
                        <h3>Latitude and Longitude</h3>
                        <div class="p-d-flex p-mb-3">
                            <div class="p-inputgroup p-mr-3">
                                <span class="p-inputgroup-addon">lat</span>
                                <input type="text" pInputText placeholder="0.00" [(ngModel)]="geo.latitude">      
                            </div>
                            <div class="p-inputgroup">
                                <span class="p-inputgroup-addon">long</span>
                                <input type="text" pInputText placeholder="-0.00"  [(ngModel)]="geo.longitude">      
                            </div>
                        </div>
                        <!-- <h3>Arrival text</h3>
                        <textarea rows="5" cols="100" pInputTextarea autoResize="autoResize"></textarea> -->
                    </p-tabPanel>
                </p-tabView>     
            </div>

        </div>
    </ng-template>
</div>

<div #menuDisplay class="overlay">
    <button (click)="hideMenu()"
        style="border: none; background-color: transparent; width: 40px; height: 40px; position: absolute; top: 2%; right: 2%;">
        <img src="/assets/images/Cross.svg" style="margin: auto;" />
    </button>
    <button (click)="onCancelClicked()"
        style="width: 100%; height: 50px; background-color: transparent; border: none; display: flex; flex-direction: row; align-items: center;">
        <p>Cancel Edit</p>
        <i class="pi pi-arrow-circle-left" style="position: absolute; right: 20px; font-size: 2rem;"></i>
    </button>
    <button (click)="togglePublish()"
        style="width: 100%; height: 50px; background-color: transparent; border: none; align-items: center;">
        <div *ngIf="!published" style="display: flex; flex-direction: row; align-items: center;">
            <p>Draft</p>
            <img src="assets/images/ToggleOff.svg" style="position: absolute; right: 20px;" />
        </div>
        <div *ngIf="published" style="display: flex; flex-direction: row; align-items: center;">
            <p>Active</p>
            <img src="assets/images/ToggleOn.svg" style="position: absolute; right: 20px;" />
        </div>
    </button>
    <div style="width: 100%; height: 1px; background-color: #CDDDD7;"></div>
    <button (click)="showDeleteConfirm()"
        style="width: 100%; height: 50px; background-color: transparent; border: none; display: flex; flex-direction: row; align-items: center;">
        <p>Delete</p>
        <img src="assets/images/Trash.svg" style="position: absolute; right: 20px;" />
    </button>
</div>

<div #deleteDisplay class="overlay"
    style="height: 400px; display: none; flex-direction: column; gap: 16px; padding: 32px; z-index: 9;">
    <div
        style="background-image: url(/assets/images/Circle.svg); object-fit: contain; background-size: contain; min-width: 66px; min-height: 66px; display: flex; justify-content: center;">
        <img src="/assets/images/TrashOutline.svg" style="width: 40px; height: 40px; margin: auto;" />
    </div>

    <p>Are you sure you want to delete the experience?</p>
    <span>This action cannot be undone</span>
    <button pButton type="button" (click)="removeDome(originalDome)"
        class="p-button-danger p-button-raised p-button-outlined button-label" label="Delete Experience"
        style="width: 100%; height: 50px; max-width: 500px;"></button>
    <button pButton type="button" (click)="hideDeleteConfirm()" class="p-button-warning p-button-raised button-label"
        label="Cancel" style="width: 100%; height: 50px; max-width: 500px;"></button>
</div>

<div #contextMenu type="context" id="menu"
    style="display: none; position: absolute; z-index: 6; background-color: #eee; border: solid 1px #0D4131; border-radius: 4px; border-width: 1px;">
    <p class="context-item" label="Remove link" id="removeLink" style="margin: 4px;">Remove Link</p>
    <p style="background-color: #042319; height: 1px; width: 100%; margin: 0px;"></p>
    <p class="context-item" label="Edit link" id="editLink" style="margin: 4px;">Edit Link</p>
</div>

<div #qrDisplay class="overlay-popup">
    <p style="text-align: center; position: absolute; top: 10%; font-size: 24px; display: flex;">Download your QR code
    </p>
    <button (click)="hideQR()"
        style="border: none; background-color: transparent; width: 40px; height: 40px; position: absolute; top: 2%; right: 2%;">
        <img src="/assets/images/Cross.svg" style="margin: auto;" />
    </button>

    <div class="overlay-center" style="padding-top: 60px;">
        <button pButton pRipple (click)="downloadQR()" aria-label="Download" label="Download"
            class="p-button-outlined p-button-success" severity="success"
            style="position: absolute; top: 10px; right: 10px; height: 30px;"></button>
        <ngx-qrcode id="qrCode2" [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="qrUrl"
            cssClass="bshadow">
        </ngx-qrcode>
        <a href="{{qrUrl}}" target="_blank">{{qrUrl}}</a>
    </div>
</div>

<div #uploadPopup class="overlay-popup" style="gap: 16px;">
    Creating Audio Files
    <p-progressBar [value]="progress" [style]="{'width': '150px', 'height': '6px'}"></p-progressBar>
    {{currentAudio}}
</div>
<p-toast></p-toast>